import { Instance, SnapshotOut, types } from 'mobx-state-tree'

import { extendLogger, LoggerContexts } from '../../utils/logger'
import { withRootStore } from '../extensions'
import { EnvironmentStages } from '../environment'
import { ShareModel } from './share.model'
import { shareSheetModalRef } from '../../components/ShareSheet/useShareSheet'
import { getEnvStage } from '../root.store'

const logger = extendLogger(LoggerContexts.ShareStore)

/**
 * A ShareStore model.
 */

export const ShareStore = types
  .model('ShareStoreModel')
  .props({
    info: types.maybe(ShareModel),
    branchReferUrl: types.maybe(types.string),
    isShareOpen: types.optional(types.boolean, false)
  })
  .extend(withRootStore)
  .actions((self) => ({
    clearShare() {
      self.info = undefined
    },
    setIsShareOpen(value: boolean) {
      //self.isShareOpen = value
      //no-op for now on web
    },
    setShare(hash: string) {
      const STAGE = process.env.EXPO_PUBLIC_STAGE
      const message = `Join my game on Poker Power: ${hash}`
      const isProd = STAGE === EnvironmentStages.prod
      const url = isProd
        ? `https://app.pokerpower.com/game/join/${hash}`
        : `https://app.dev.pokerpower.com/game/join/${hash}`

      this.setInfo({ hash, message, url })
    },
    setInfo({ hash, message, url }: { hash: string; message: string; url: string }) {
      ShareModel.create({ hash, message, url })
      self.info = ShareModel.create({ hash, message, url })
    },
    setBranchReferUrl(data: string) {
      self.branchReferUrl = data
    }
  }))
  .actions((self) => ({
    async promptShare(message: string, title: string, url: string) {
      if (message && url) {
        self.info = ShareModel.create({ hash: '', message, url })
      }

      try {
        shareSheetModalRef.current?.present()
      } catch (error) {
        logger.warn(error)
      }
    },
    async referBranchSubscription() {
      // Listener
      // branch.subscribe({
      //   onOpenStart: ({ uri, cachedInitialEvent }) => {
      //     if (uri) self.rootStore.share.setBranchReferUrl(uri)
      //     logger.info('subscribe onOpenStart, will open ' + uri + ' cachedInitialEvent is ' + cachedInitialEvent)
      //   },
      //   onOpenComplete: async ({ error, params, uri }) => {
      //     if (error) {
      //       console.error('subscribe onOpenComplete, Error from opening uri: ' + uri + ' error: ' + error)
      //       return
      //     } else if (params && params?.userId) {
      //       const parentUserId = params && params?.userId.toString()
      //       await this.createReferring(parentUserId, params)
      //       if (!params['+clicked_branch_link']) {
      //         if (params['+non_branch_link']) {
      //           console.log('non_branch_link: ' + uri)
      //           // Route based on non-Branch links
      //           return
      //         }
      //       } else {
      //         // Route based on Branch link data
      //         return
      //       }
      //     }
      //   }
      // })
    },

    async createReferring(parentUserId?: string, params?: unknown) {
      const userId = self.rootStore.session.user?._id
      try {
        if (parentUserId) {
          const response = await self.rootStore.api.mutateCreateReferringParams({
            parentUserId,
            childUserId: userId,
            params
          })
          console.log('mutateCreateReferringParams response==>>', response.createReferringParams)
        } else {
          throw new Error('Unauthorized user')
        }
      } catch (error) {
        console.log('mutateCreateReferringParams response==>>', error)
        throw error
      }
    }
  }))
  .actions((self) => ({
    async promptGameShare() {
      if (!self.info) {
        logger.error('Missing share information')
        return
      }
      const { message, url } = self.info
      await self.promptShare(message, message, url)
    }
  }))

/**
 * The ShareStore instance.
 */
export type ShareStoreType = Instance<typeof ShareStore>

/**
 * The data of a ShareStore.
 */
export type ShareStoreSnapshot = SnapshotOut<typeof ShareStore>
